import { getMinValue, getMaxValue } from '@@/utils/ChartUtils';

export default {
  computed: {
    hasRecentSnow() {
      return this.location?.weather_stations_recent_snow === true;
    },

    hasWeatherStations() {
      return this.weatherStations?.length > 0;
    },

    weatherStations() {
      return this.location?.weather_stations;
    },

    weatherStationsCount() {
      return this.location?.weather_stations_count;
    },
  },
};

export const getObservationHourlyRange = (weatherStations = []) => {
  /* eslint camelcase: off */
  const precipSnows = weatherStations
    .flatMap(({ observation_hourly }) => observation_hourly?.map(({ precip_snow }) => precip_snow))
    .filter((value) => value != null);

  const max = getMaxValue(precipSnows) || 0;
  const min = getMinValue(precipSnows) || 0;

  return { max, min };
};
